exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "manage-purchase-navbar>ul>li>a[aria-selected=true]{border-bottom-color:#fc0;font-family:Renault Regular,Helvetica,Arial,sans-serif}.disabledClick{pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/manage-purchase/common/manage-purchase-navbar/manage-purchase-navbar.styl
// module id = 907
// module chunks = 0